(() => {
  const initialize = () => {
    const mobile = window.matchMedia('(max-width: 989.98px)');
    document.querySelectorAll('header-drawer').forEach((drawer) => {
      const nav = drawer.querySelector('nav.slide-out-menu');
      if (!nav || !nav.querySelector('.ew-mobile-routes') || nav.dataset.ewMobileMenuBound) return;
      nav.dataset.ewMobileMenuBound = 'true';
      const details = drawer.querySelector('details');
      const primary = nav.querySelector('.primary-menu-panel');
      const panels = Array.from(nav.querySelectorAll('.menu-panel'));
      const buttons = Array.from(nav.querySelectorAll('button.menu-link'));
      const openers = new WeakMap();
      const original = new Map();
      let pending = 0;
      let wasOpen = false;
      let closeFocusTimer = 0;
      [primary, ...panels, ...buttons].filter(Boolean).forEach((element) => {
        original.set(element, {
          inert: element.inert,
          attributes: Object.fromEntries(['aria-hidden', 'aria-controls', 'aria-expanded', 'aria-label'].map((name) => [name, element.getAttribute(name)]))
        });
      });
      const panelFor = (ref) => ref ? panels.find((panel) => panel.dataset.menu === ref) : null;
      const isOpen = () => details.open && details.classList.contains('menu-opening');
      const visible = (element) => {
        if (!element || !element.isConnected || element.inert) return false;
        const panel = element.closest('.menu-panel');
        if (panel && !panel.classList.contains('is-active')) return false;
        if (element.closest('.primary-menu-panel') && panels.some((item) => item.classList.contains('is-active'))) return false;
        const style = window.getComputedStyle(element);
        return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
      };
      const restore = () => {
        original.forEach((state, element) => {
          element.inert = state.inert;
          Object.entries(state.attributes).forEach(([name, value]) => value === null ? element.removeAttribute(name) : element.setAttribute(name, value));
        });
      };
      const restoreCloseFocus = () => {
        closeFocusTimer = 0;
        if (!mobile.matches || details.open || isOpen()) return;
        const focused = document.activeElement;
        if (focused && focused !== document.body && !drawer.contains(focused)) return;
        drawer.querySelector('summary.drawer__button')?.focus({ preventScroll: true });
      };
      const synchronize = () => {
        const open = isOpen();
        if (!mobile.matches) {
          window.clearTimeout(closeFocusTimer);
          closeFocusTimer = 0;
          wasOpen = open;
          restore();
          return;
        }
        if (wasOpen && !open) {
          pending++;
          window.clearTimeout(closeFocusTimer);
          // The native drawer removes open after 500ms; its former focus can then fall to BODY.
          closeFocusTimer = window.setTimeout(restoreCloseFocus, 550);
        } else if (!wasOpen && open) {
          window.clearTimeout(closeFocusTimer);
          closeFocusTimer = 0;
        }
        wasOpen = open;
        const active = open ? panels.find((panel) => panel.classList.contains('is-active')) : null;
        panels.forEach((panel, index) => {
          if (!panel.id) panel.id = 'EW-mobile-panel-' + details.id + '-' + index;
          panel.inert = panel !== active;
          panel.setAttribute('aria-hidden', String(panel !== active));
        });
        primary.inert = Boolean(active);
        primary.setAttribute('aria-hidden', String(Boolean(active)));
        buttons.forEach((button) => {
          const controlled = panelFor(button.dataset.ref);
          if (controlled) button.setAttribute('aria-controls', controlled.id);
          if (button.classList.contains('menu-header')) {
            if (drawer.dataset.ewMobileBackLabel) button.setAttribute('aria-label', drawer.dataset.ewMobileBackLabel);
          } else if (controlled) {
            button.setAttribute('aria-expanded', String(controlled === active));
          }
        });
      };
      const headerFor = (panel) => Array.from(panel.querySelectorAll('button.menu-header')).find(visible);
      const openerFor = (source, target) => {
        const recorded = openers.get(source);
        if (visible(recorded)) return recorded;
        const scope = target || primary;
        return Array.from(scope.querySelectorAll('button.menu-link')).find((button) => button.dataset.ref === source.dataset.menu && visible(button));
      };
      nav.addEventListener('click', (event) => {
        if (!mobile.matches || !isOpen()) return;
        const button = event.target.closest('button.menu-link');
        if (!button || !nav.contains(button)) return;
        const source = button.closest('.menu-panel');
        const target = panelFor(button.dataset.ref);
        const back = button.classList.contains('menu-header');
        if (target && !back) openers.set(target, button);
        const revision = ++pending;
        queueMicrotask(() => window.requestAnimationFrame(() => {
          if (revision !== pending || !mobile.matches || !isOpen()) return;
          synchronize();
          if (target && !target.classList.contains('is-active')) return;
          let focusTarget;
          if (back && source) focusTarget = openerFor(source, target);
          if (!focusTarget && target) focusTarget = headerFor(target);
          if (!focusTarget && back) focusTarget = Array.from(primary.querySelectorAll('button.menu-link')).find(visible);
          if (visible(focusTarget)) focusTarget.focus({ preventScroll: true });
        }));
      });
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') queueMicrotask(synchronize);
      });
      new MutationObserver(synchronize).observe(details, { attributes: true, attributeFilter: ['class', 'open'], subtree: true });
      mobile.addEventListener('change', () => { pending++; synchronize(); });
      synchronize();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
